import { KEYS } from './keys';

const en = {
    [KEYS.COMMON_EMAIL]: 'Email',
    [KEYS.COMMON_PASSWORD]: 'Password',
    [KEYS.COMMON_NAME]: 'Name',
    [KEYS.COMMON_BACK]: 'Back',
    [KEYS.COMMON_LOADING]: 'Loading...',
    [KEYS.COMMON_BACK_TO_LOGIN]: 'Back to login',
    [KEYS.COMMON_ERROR_GENERIC]: 'Something went wrong. Please try again.',
    [KEYS.COMMON_NEVER]: 'Never',
    [KEYS.COMMON_CANCEL]: 'Cancel',
    [KEYS.COMMON_SAVE]: 'Save',
    [KEYS.COMMON_CLOSE]: 'Close',
    [KEYS.COMMON_CONFIRM]: 'Confirm',
    [KEYS.COMMON_DELETE]: 'Delete',
    [KEYS.COMMON_EDIT]: 'Edit',
    [KEYS.COMMON_ADD]: 'Add',
    [KEYS.COMMON_RETRY]: 'Retry',
    [KEYS.COMMON_VIEW]: 'View',
    [KEYS.COMMON_RESET]: 'Reset',
    [KEYS.COMMON_YES]: 'Yes',
    [KEYS.COMMON_NO]: 'No',
    [KEYS.COMMON_DESCRIPTION]: 'Description',
    [KEYS.COMMON_PHONE]: 'Phone',
    [KEYS.COMMON_WEBSITE]: 'Website',
    [KEYS.COMMON_NOTES]: 'Notes',
    [KEYS.COMMON_STATUS]: 'Status',
    [KEYS.COMMON_DETAILS]: 'Details',
    [KEYS.COMMON_LABEL]: 'Label',
    [KEYS.COMMON_VALUE]: 'Value',
    [KEYS.COMMON_UNIT]: 'Unit',
    [KEYS.COMMON_TYPE]: 'Type',
    [KEYS.COMMON_SERVICE]: 'Service',
    [KEYS.COMMON_SUPPLIER]: 'Supplier',
    [KEYS.COMMON_FREQUENCY]: 'Frequency',
    [KEYS.COMMON_TITLE]: 'Title',
    [KEYS.COMMON_AMOUNT]: 'Amount',
    [KEYS.COMMON_CREATING]: 'Creating...',
    [KEYS.COMMON_SAVING]: 'Saving...',
    [KEYS.COMMON_DELETING]: 'Deleting...',
    [KEYS.COMMON_UPDATING]: 'Updating...',
    [KEYS.COMMON_GENERATING]: 'Generating...',
    [KEYS.COMMON_ADDING]: 'Adding...',
    [KEYS.COMMON_SAVE_CHANGES]: 'Save Changes',
    [KEYS.COMMON_CANNOT_UNDO]: 'This action cannot be undone',
    [KEYS.COMMON_DONE]: 'Done',
    [KEYS.COMMON_COPY]: 'Copy',
    [KEYS.COMMON_COPIED]: 'Copied',
    [KEYS.COMMON_ERROR_MAX_CHARS]: 'Maximum 191 characters',
    [KEYS.COMMON_ERROR_INVALID_EMAIL]: 'Invalid email format',
    [KEYS.COMMON_ERROR_INVALID_URL]: 'Invalid URL format',
    [KEYS.COMMON_DATE_ISSUED]: 'Issue Date',
    [KEYS.COMMON_DATE_DUE]: 'Due Date',
    [KEYS.COMMON_DATE_PAID]: 'Paid Date',
    [KEYS.COMMON_MARK_AS_PAID]: 'Mark as Paid',
    [KEYS.COMMON_MARK_AS_READ]: 'Mark as read',
    [KEYS.COMMON_LOAD_MORE]: 'Load more',
    [KEYS.COMMON_UNKNOWN_SERVICE]: 'Unknown Service',
    [KEYS.COMMON_CREATED_BY]: 'Created by',
    [KEYS.COMMON_ACTIONS]: 'Actions',
    [KEYS.COMMON_OPTIONAL]: 'optional',

    [KEYS.TYPE_ELECTRICITY]: 'Electricity',
    [KEYS.TYPE_NATURAL_GAS]: 'Natural Gas',
    [KEYS.TYPE_WATER]: 'Water',
    [KEYS.TYPE_PHONE]: 'Phone',
    [KEYS.TYPE_INTERNET]: 'Internet',
    [KEYS.TYPE_OTHER]: 'Other',

    [KEYS.EMPTY_SUPPLIERS_TITLE]: 'No suppliers yet',
    [KEYS.EMPTY_SUPPLIERS_DESCRIPTION]: 'Add your first supplier to start tracking.',
    [KEYS.EMPTY_SUPPLIERS_ACTION]: 'Add Supplier',
    [KEYS.EMPTY_SERVICES_TITLE]: 'No services found',
    [KEYS.EMPTY_SERVICES_DESCRIPTION]: 'Add a service to start tracking bills.',
    [KEYS.EMPTY_SERVICES_ACTION]: 'Add Service',
    [KEYS.EMPTY_INVOICES_TITLE]: 'No invoices found',
    [KEYS.EMPTY_INVOICES_DESCRIPTION]: 'Start tracking by adding an invoice.',
    [KEYS.EMPTY_INVOICES_ACTION]: 'Add Invoice',
    [KEYS.EMPTY_READINGS_TITLE]: 'No readings found',
    [KEYS.EMPTY_READINGS_DESCRIPTION]: 'Start tracking by adding a meter reading.',
    [KEYS.EMPTY_READINGS_ACTION]: 'Add Reading',
    [KEYS.EMPTY_CREDENTIALS_TITLE]: 'No credentials yet',
    [KEYS.EMPTY_CREDENTIALS_DESCRIPTION]: 'Store portal login details securely.',
    [KEYS.EMPTY_CREDENTIALS_ACTION]: 'Add Credential',
    [KEYS.EMPTY_REMINDERS_TITLE]: 'No reminders yet',
    [KEYS.EMPTY_REMINDERS_DESCRIPTION]: 'Add a reminder to stay on top of due dates.',
    [KEYS.EMPTY_REMINDERS_ACTION]: 'Add Reminder',
    [KEYS.EMPTY_SEARCH_TITLE]: 'No results found',
    [KEYS.EMPTY_SEARCH_DESCRIPTION]: 'Nothing matches "{query}".',
    [KEYS.EMPTY_SEARCH_DESCRIPTION_GENERIC]: 'Try adjusting your search.',
    [KEYS.EMPTY_ERROR_TITLE]: 'Something went wrong',
    [KEYS.EMPTY_ERROR_DESCRIPTION]: 'An error occurred. Please try again.',

    [KEYS.LOGIN_TAGLINE]: 'Sign in to your account',
    [KEYS.LOGIN_FORGOT_PASSWORD]: 'Forgot password?',
    [KEYS.LOGIN_SUBMIT]: 'Sign in',
    [KEYS.LOGIN_SUBMITTING]: 'Signing in...',
    [KEYS.LOGIN_NO_ACCOUNT]: "Don't have an account?",
    [KEYS.LOGIN_CREATE_ONE]: 'Create one',
    [KEYS.LOGIN_RESET_SUCCESS]: 'Your password has been reset. Sign in below.',
    [KEYS.LOGIN_ERROR_GENERIC]: 'An error occurred during login',
    [KEYS.LOGIN_REMEMBER_ME]: 'Remember me',

    [KEYS.REGISTER_TAGLINE_INVITE]: 'Enter your invite code',
    [KEYS.REGISTER_TAGLINE_FORM]: 'Create your account',
    [KEYS.REGISTER_INVITE_CODE]: 'Invite Code',
    [KEYS.REGISTER_INVITE_PLACEHOLDER]: 'Paste your invite code here',
    [KEYS.REGISTER_CONTINUE]: 'Continue',
    [KEYS.REGISTER_CONTINUING]: 'Verifying...',
    [KEYS.REGISTER_CONFIRM_PASSWORD]: 'Confirm Password',
    [KEYS.REGISTER_SUBMIT]: 'Create Account',
    [KEYS.REGISTER_SUBMITTING]: 'Creating account...',
    [KEYS.REGISTER_ALREADY_ACCOUNT]: 'Already have an account?',
    [KEYS.REGISTER_SIGN_IN]: 'Sign in',
    [KEYS.REGISTER_ERROR_INVITE_REQUIRED]: 'Please enter an invite code',
    [KEYS.REGISTER_ERROR_PASSWORDS_MISMATCH]: 'Passwords do not match',
    [KEYS.REGISTER_ERROR_GENERIC]: 'An error occurred during registration',

    [KEYS.HOME_TITLE]: 'Dashboard',
    [KEYS.HOME_SUBTITLE]: 'Overview of your bills and services',
    [KEYS.HOME_STAT_TOTAL_SERVICES]: 'Total Services',
    [KEYS.HOME_STAT_MONTHLY_SPEND]: 'Monthly Spend',
    [KEYS.HOME_STAT_SUPPLIERS]: 'Suppliers',
    [KEYS.HOME_STAT_SERVICE_TYPES]: 'Service Types',
    [KEYS.HOME_UPCOMING_DUE]: 'Upcoming Due',
    [KEYS.HOME_OUTSTANDING_BY_CATEGORY]: 'Outstanding by Category',
    [KEYS.HOME_NO_UPCOMING_INVOICES]: 'No upcoming invoices',
    [KEYS.HOME_NO_OUTSTANDING_INVOICES]: 'No outstanding invoices',
    [KEYS.HOME_ERROR_LOAD]: 'Failed to load dashboard data',

    [KEYS.SUPPLIERS_TITLE]: 'Suppliers',
    [KEYS.SUPPLIERS_SUBTITLE]: 'Manage your service providers',
    [KEYS.SUPPLIERS_ADD]: 'Add Supplier',
    [KEYS.SUPPLIERS_ERROR_LOAD]: 'Failed to load suppliers',
    [KEYS.SUPPLIERS_NOT_FOUND]: 'Supplier not found',
    [KEYS.SUPPLIERS_BACK]: 'Back to Suppliers',

    [KEYS.SERVICES_TITLE]: 'Services',
    [KEYS.SERVICES_SUBTITLE]: 'All your tracked services by category',
    [KEYS.SERVICES_ERROR_LOAD]: 'Failed to load services',
    [KEYS.SERVICES_NOT_FOUND]: 'Service not found',
    [KEYS.SERVICES_BACK]: 'Back to Services',
    [KEYS.SERVICES_ADD]: 'Add Service',

    [KEYS.SERVICE_DETAIL_EDIT]: 'Edit',
    [KEYS.SERVICE_DETAIL_DETAILS]: 'Details',
    [KEYS.SERVICE_DETAIL_TYPE]: 'Type',
    [KEYS.SERVICE_DETAIL_SUPPLIER]: 'Supplier',
    [KEYS.SERVICE_DETAIL_DESCRIPTION]: 'Description',
    [KEYS.SERVICE_DETAIL_NAV_READINGS]: 'Readings',
    [KEYS.SERVICE_DETAIL_NAV_READINGS_SUB]: 'Meter & consumption values',
    [KEYS.SERVICE_DETAIL_NAV_INVOICES]: 'Invoices',
    [KEYS.SERVICE_DETAIL_NAV_INVOICES_SUB]: 'Bills & payment tracking',
    [KEYS.SERVICE_DETAIL_NAV_READING_TEMPLATES]: 'Reading Templates',
    [KEYS.SERVICE_DETAIL_NAV_READING_TEMPLATES_SUB]: 'Reusable reading presets',
    [KEYS.SERVICE_DETAIL_NAV_INVOICE_TEMPLATES]: 'Invoice Templates',
    [KEYS.SERVICE_DETAIL_NAV_INVOICE_TEMPLATES_SUB]: 'Reusable invoice blueprints',
    [KEYS.SERVICE_DETAIL_NAV_ACTIONS]: 'Scheduled Actions',
    [KEYS.SERVICE_DETAIL_NAV_ACTIONS_SUB]: 'Automated creation rules',
    [KEYS.SERVICE_DETAIL_INVOICE_HISTORY]: 'Invoice History',

    [KEYS.SERVICE_READINGS_TITLE]: 'Readings',
    [KEYS.SERVICE_READINGS_ADD]: 'Add Reading',
    [KEYS.SERVICE_READINGS_ERROR_LOAD]: 'Failed to load readings',
    [KEYS.SERVICE_READINGS_COL_VALUE]: 'Value',
    [KEYS.SERVICE_READINGS_COL_UNIT]: 'Unit',
    [KEYS.SERVICE_READINGS_COL_READ_DATE]: 'Read Date',
    [KEYS.SERVICE_READINGS_COL_NOTES]: 'Notes',

    [KEYS.SERVICE_INVOICES_TITLE]: 'Invoices',
    [KEYS.SERVICE_INVOICES_ADD]: 'Add Invoice',
    [KEYS.SERVICE_INVOICES_ERROR_LOAD]: 'Failed to load invoices',

    [KEYS.SERVICE_INVOICE_TEMPLATES_TITLE]: 'Invoice Templates',
    [KEYS.SERVICE_INVOICE_TEMPLATES_ADD]: 'Add Template',
    [KEYS.SERVICE_INVOICE_TEMPLATES_ERROR_LOAD]: 'Failed to load invoice templates',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_LABEL]: 'Label',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_NAME]: 'Name',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_AMOUNT]: 'Amount',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_ISSUE_DATE]: 'Issue Date',
    [KEYS.SERVICE_INVOICE_TEMPLATES_COL_DUE_DATE]: 'Due Date',
    [KEYS.SERVICE_INVOICE_TEMPLATES_EMPTY]: 'No invoice templates yet. Create a reusable blueprint for this service.',

    [KEYS.SERVICE_READING_TEMPLATES_TITLE]: 'Reading Templates',
    [KEYS.SERVICE_READING_TEMPLATES_ADD]: 'Add Template',
    [KEYS.SERVICE_READING_TEMPLATES_ERROR_LOAD]: 'Failed to load reading templates',
    [KEYS.SERVICE_READING_TEMPLATES_COL_LABEL]: 'Label',
    [KEYS.SERVICE_READING_TEMPLATES_EMPTY]: 'No reading templates yet. Create a reusable preset for this service.',

    [KEYS.SERVICE_ACTIONS_TITLE]: 'Scheduled Actions',
    [KEYS.SERVICE_ACTIONS_ADD]: 'Add Action',
    [KEYS.SERVICE_ACTIONS_ERROR_LOAD]: 'Failed to load scheduled actions',
    [KEYS.SERVICE_ACTIONS_COL_TYPE]: 'Type',
    [KEYS.SERVICE_ACTIONS_COL_FREQUENCY]: 'Frequency',
    [KEYS.SERVICE_ACTIONS_COL_NEXT_RUN]: 'Next Run',
    [KEYS.SERVICE_ACTIONS_COL_LAST_RUN]: 'Last Run',
    [KEYS.SERVICE_ACTIONS_COL_ACTIVE]: 'Active',
    [KEYS.SERVICE_ACTIONS_EMPTY]: 'No scheduled actions yet. Set up automation to create invoices or readings on a schedule.',
    [KEYS.SERVICE_ACTIONS_TYPE_CREATE_INVOICE]: 'Create Invoice',
    [KEYS.SERVICE_ACTIONS_TYPE_CREATE_READING]: 'Create Reading',
    [KEYS.SERVICE_ACTIONS_FREQ_ONCE]: 'Once',
    [KEYS.SERVICE_ACTIONS_FREQ_DAILY]: 'Daily',
    [KEYS.SERVICE_ACTIONS_FREQ_WEEKLY]: 'Weekly',
    [KEYS.SERVICE_ACTIONS_FREQ_MONTHLY]: 'Monthly',
    [KEYS.SERVICE_ACTIONS_FREQ_YEARLY]: 'Yearly',

    [KEYS.INVOICES_TITLE]: 'Invoices',
    [KEYS.INVOICES_SUBTITLE]: 'Track and manage your bills',
    [KEYS.INVOICES_ADD]: 'Add Invoice',
    [KEYS.INVOICES_ERROR_LOAD]: 'Failed to load invoices',
    [KEYS.INVOICES_COL_NAME]: 'Name',
    [KEYS.INVOICES_COL_SERVICE]: 'Service',
    [KEYS.INVOICES_COL_ISSUED]: 'Issued',
    [KEYS.INVOICES_COL_DUE]: 'Due',
    [KEYS.INVOICES_COL_AMOUNT]: 'Amount',
    [KEYS.INVOICES_COL_STATUS]: 'Status',
    [KEYS.INVOICES_FILTER_ALL]: 'All statuses',
    [KEYS.INVOICES_FILTER_UNPAID]: 'Unpaid',
    [KEYS.INVOICES_FILTER_PAID]: 'Paid',
    [KEYS.INVOICES_FILTER_OVERDUE]: 'Overdue',
    [KEYS.INVOICES_RESET_FILTERS]: 'Reset',
    [KEYS.INVOICES_STATUS_PAID]: 'paid',
    [KEYS.INVOICES_STATUS_PENDING]: 'pending',
    [KEYS.INVOICES_STATUS_OVERDUE]: 'overdue',
    [KEYS.INVOICES_STATUS_UPCOMING]: 'upcoming',
    [KEYS.INVOICES_LOAD_MORE]: 'Load more',
    [KEYS.INVOICES_LOADING_MORE]: 'Loading...',
    [KEYS.CREATED_BY_USER]: 'Manual',
    [KEYS.CREATED_BY_AUTOMATION]: 'Automated',
    [KEYS.CREATED_BY_SCHEDULE]: 'Scheduled',
    [KEYS.CREATED_BY_UNKNOWN]: 'Unknown',

    [KEYS.REMINDERS_TITLE]: 'Reminders',
    [KEYS.REMINDERS_SUBTITLE]: 'Stay on top of recurring tasks and due dates',
    [KEYS.REMINDERS_ADD]: 'Add Reminder',
    [KEYS.REMINDERS_ERROR_LOAD]: 'Failed to load reminders',
    [KEYS.REMINDERS_COL_TITLE]: 'Title',
    [KEYS.REMINDERS_COL_DUE_DATE]: 'Due Date',
    [KEYS.REMINDERS_COL_FREQUENCY]: 'Frequency',
    [KEYS.REMINDERS_COL_STATUS]: 'Status',
    [KEYS.REMINDERS_STATUS_OVERDUE]: 'overdue',
    [KEYS.REMINDERS_STATUS_ACTIVE]: 'active',
    [KEYS.REMINDERS_STATUS_INACTIVE]: 'inactive',
    [KEYS.REMINDERS_FREQ_QUARTERLY]: 'Quarterly',

    [KEYS.PROFILE_EMAIL]: 'Email',
    [KEYS.PROFILE_MEMBER_SINCE]: 'Member Since',
    [KEYS.PROFILE_EDIT]: 'Edit Profile',
    [KEYS.PROFILE_DELETE]: 'Delete Account',
    [KEYS.PROFILE_INTEGRATIONS]: 'Integrations',
    [KEYS.PROFILE_API_KEYS_LABEL]: 'API Keys',
    [KEYS.PROFILE_API_KEYS_DESCRIPTION]: 'Manage access tokens for external integrations',
    [KEYS.PROFILE_INVITE_CODES_LABEL]: 'Invite Codes',
    [KEYS.PROFILE_INVITE_CODES_DESCRIPTION]: 'Generate single-use codes to invite new users',
    [KEYS.PROFILE_ERROR_LOAD]: 'Failed to load profile data',
    [KEYS.PROFILE_UPDATE_SUCCESS]: 'Profile updated successfully',
    [KEYS.PROFILE_PREFERENCES]: 'Preferences',
    [KEYS.PROFILE_CURRENCY]: 'Currency Symbol',

    [KEYS.API_KEYS_TITLE]: 'API Keys',
    [KEYS.API_KEYS_SUBTITLE]: 'Manage long-lived tokens for external integrations and scripts',
    [KEYS.API_KEYS_ADD]: 'Add API Key',
    [KEYS.API_KEYS_ERROR_LOAD]: 'Failed to load API keys',
    [KEYS.API_KEYS_COL_NAME]: 'Name',
    [KEYS.API_KEYS_COL_ABILITIES]: 'Abilities',
    [KEYS.API_KEYS_COL_LAST_USED]: 'Last Used',
    [KEYS.API_KEYS_COL_EXPIRES]: 'Expires',
    [KEYS.API_KEYS_FULL_ACCESS]: 'Full Access',
    [KEYS.API_KEYS_SCOPES_SINGULAR]: '{n} scope',
    [KEYS.API_KEYS_SCOPES_PLURAL]: '{n} scopes',
    [KEYS.API_KEYS_EMPTY_TITLE]: 'No API keys yet',
    [KEYS.API_KEYS_EMPTY_DESCRIPTION]: 'Create a key to allow external apps to act on your behalf',

    [KEYS.INVITE_CODES_TITLE]: 'Invite Codes',
    [KEYS.INVITE_CODES_SUBTITLE]: 'Generate single-use codes to invite new users to the platform',
    [KEYS.INVITE_CODES_GENERATE]: 'Generate Code',
    [KEYS.INVITE_CODES_GENERATING]: 'Generating...',
    [KEYS.INVITE_CODES_ERROR_LOAD]: 'Failed to load invite codes',
    [KEYS.INVITE_CODES_COL_CODE]: 'Code',
    [KEYS.INVITE_CODES_COL_STATUS]: 'Status',
    [KEYS.INVITE_CODES_COL_USED]: 'Used',
    [KEYS.INVITE_CODES_COL_CREATED]: 'Created',
    [KEYS.INVITE_CODES_STATUS_USED]: 'Used',
    [KEYS.INVITE_CODES_STATUS_UNUSED]: 'Unused',
    [KEYS.INVITE_CODES_EMPTY_TITLE]: 'No invite codes yet',
    [KEYS.INVITE_CODES_EMPTY_DESCRIPTION]: 'Generate a code to invite someone to create an account',

    [KEYS.NOTIFICATIONS_TITLE]: 'Notifications',
    [KEYS.NOTIFICATIONS_SUBTITLE]: 'Reminders, overdue invoices, and upcoming payments',
    [KEYS.NOTIFICATIONS_MARK_ALL_READ]: 'Mark all as read',
    [KEYS.NOTIFICATIONS_MARK_READ]: 'Mark as read',
    [KEYS.NOTIFICATIONS_EMPTY]: "You're all caught up!",
    [KEYS.NOTIFICATIONS_PUSH_TITLE]: 'Push Notifications',
    [KEYS.NOTIFICATIONS_PUSH_DESCRIPTION]: 'Get notified about overdue invoices and due reminders even when the app is closed.',
    [KEYS.NOTIFICATIONS_PUSH_ENABLE]: 'Enable notifications',
    [KEYS.NOTIFICATIONS_PUSH_DISABLE]: 'Disable notifications',
    [KEYS.NOTIFICATIONS_PUSH_NOT_SUPPORTED]: 'Push notifications are not supported in your browser.',
    [KEYS.NOTIFICATIONS_PUSH_PERMISSION_DENIED]: 'Notification permission was denied. Enable it in your browser settings.',
    [KEYS.NOTIFICATIONS_PUSH_ERROR]: 'Failed to update notification preference. Please try again.',
    [KEYS.NOTIFICATIONS_ERROR_LOAD]: 'Failed to load notifications. Please try again.',
    [KEYS.NOTIFICATIONS_CLEAR_READ]: 'Clear read',

    [KEYS.SUPPLIER_ADD_TITLE]: 'Add New Supplier',
    [KEYS.SUPPLIER_ADD_SUBTITLE]: 'Fill in the supplier details below',
    [KEYS.SUPPLIER_ADD_SUBMIT]: 'Add Supplier',
    [KEYS.SUPPLIER_ADD_SUBMITTING]: 'Adding...',
    [KEYS.SUPPLIER_ADD_ERROR]: 'Failed to create supplier. Please try again.',
    [KEYS.SUPPLIER_EDIT_TITLE]: 'Edit Supplier',
    [KEYS.SUPPLIER_EDIT_SUBTITLE]: 'Update supplier details',
    [KEYS.SUPPLIER_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.SUPPLIER_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.SUPPLIER_EDIT_ERROR]: 'Failed to update supplier. Please try again.',
    [KEYS.SUPPLIER_DELETE_TITLE]: 'Delete Supplier',
    [KEYS.SUPPLIER_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.SUPPLIER_DELETE_BODY]: 'All data associated with this supplier will be permanently removed.',
    [KEYS.SUPPLIER_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.SUPPLIER_DELETE_ERROR]: 'Failed to delete supplier. Please try again.',

    [KEYS.CREDENTIAL_ADD_TITLE]: 'Add Credential',
    [KEYS.CREDENTIAL_ADD_SUBTITLE]: 'Store portal login details securely',
    [KEYS.CREDENTIAL_ADD_SUBMIT]: 'Add Credential',
    [KEYS.CREDENTIAL_ADD_SUBMITTING]: 'Adding...',
    [KEYS.CREDENTIAL_ADD_ERROR]: 'Failed to create credential. Please try again.',
    [KEYS.CREDENTIAL_EDIT_TITLE]: 'Edit Credential',
    [KEYS.CREDENTIAL_EDIT_SUBTITLE]: 'Update portal login details',
    [KEYS.CREDENTIAL_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.CREDENTIAL_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.CREDENTIAL_EDIT_ERROR]: 'Failed to update credential. Please try again.',
    [KEYS.CREDENTIAL_DELETE_TITLE]: 'Delete Credential',
    [KEYS.CREDENTIAL_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.CREDENTIAL_DELETE_BODY]: 'This will permanently remove the stored login details.',
    [KEYS.CREDENTIAL_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.CREDENTIAL_DELETE_ERROR]: 'Failed to delete credential. Please try again.',
    [KEYS.CREDENTIAL_VIEW_TITLE]: 'View Credential',
    [KEYS.CREDENTIAL_VIEW_USERNAME]: 'Username',
    [KEYS.CREDENTIAL_VIEW_PASSWORD]: 'Password',
    [KEYS.CREDENTIAL_VIEW_COPY]: 'Copy',
    [KEYS.CREDENTIAL_VIEW_COPIED]: 'Copied!',
    [KEYS.CREDENTIAL_VIEW_AUTO_CLOSE]: 'Auto-closing in {n}s',
    [KEYS.CREDENTIAL_VIEW_NOTES]: 'Notes',
    [KEYS.CREDENTIAL_WARNING_TITLE]: 'Security Warning',
    [KEYS.CREDENTIAL_WARNING_BODY]: 'You are about to view sensitive credentials. Make sure no one is watching your screen.',
    [KEYS.CREDENTIAL_WARNING_CONFIRM]: 'View Credentials',

    [KEYS.SERVICE_ADD_TITLE]: 'Add New Service',
    [KEYS.SERVICE_ADD_SUBTITLE]: 'Fill in the service details below',
    [KEYS.SERVICE_ADD_SUBMIT]: 'Add Service',
    [KEYS.SERVICE_ADD_SUBMITTING]: 'Adding...',
    [KEYS.SERVICE_ADD_ERROR]: 'Failed to create service. Please try again.',
    [KEYS.SERVICE_ADD_TYPE_REQUIRED]: 'Type is required',
    [KEYS.SERVICE_EDIT_TITLE]: 'Edit Service',
    [KEYS.SERVICE_EDIT_SUBTITLE]: 'Update service details',
    [KEYS.SERVICE_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.SERVICE_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.SERVICE_EDIT_ERROR]: 'Failed to update service. Please try again.',
    [KEYS.SERVICE_DELETE_TITLE]: 'Delete Service',
    [KEYS.SERVICE_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.SERVICE_DELETE_BODY]: 'All data associated with this service will be permanently removed.',
    [KEYS.SERVICE_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.SERVICE_DELETE_ERROR]: 'Failed to delete service. Please try again.',

    [KEYS.READING_ADD_TITLE]: 'Add Reading',
    [KEYS.READING_ADD_SUBMIT]: 'Add Reading',
    [KEYS.READING_ADD_SUBMITTING]: 'Adding...',
    [KEYS.READING_ADD_ERROR]: 'Failed to create reading. Please try again.',
    [KEYS.READING_EDIT_TITLE]: 'Edit Reading',
    [KEYS.READING_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.READING_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.READING_EDIT_ERROR]: 'Failed to update reading. Please try again.',
    [KEYS.READING_DELETE_TITLE]: 'Delete Reading',
    [KEYS.READING_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.READING_DELETE_BODY]: 'This reading will be permanently deleted.',
    [KEYS.READING_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.READING_DELETE_ERROR]: 'Failed to delete reading. Please try again.',
    [KEYS.READING_VIEW_TITLE]: 'Reading Details',
    [KEYS.READING_VIEW_READ_DATE]: 'Read Date',
    [KEYS.READING_FIELD_FILE]: 'Attached File',
    [KEYS.READING_FIELD_VALUE_REQUIRED]: 'Value is required',
    [KEYS.READING_FIELD_DATE_REQUIRED]: 'Read date is required',

    [KEYS.READING_TEMPLATE_ADD_TITLE]: 'Add Reading Template',
    [KEYS.READING_TEMPLATE_ADD_SUBMIT]: 'Add Template',
    [KEYS.READING_TEMPLATE_ADD_SUBMITTING]: 'Adding...',
    [KEYS.READING_TEMPLATE_ADD_ERROR]: 'Failed to create reading template. Please try again.',
    [KEYS.READING_TEMPLATE_EDIT_TITLE]: 'Edit Reading Template',
    [KEYS.READING_TEMPLATE_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.READING_TEMPLATE_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.READING_TEMPLATE_EDIT_ERROR]: 'Failed to update reading template. Please try again.',
    [KEYS.READING_TEMPLATE_DELETE_TITLE]: 'Delete Reading Template',
    [KEYS.READING_TEMPLATE_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.READING_TEMPLATE_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.READING_TEMPLATE_DELETE_ERROR]: 'Failed to delete reading template. Please try again.',
    [KEYS.READING_TEMPLATE_FIELD_LABEL_REQUIRED]: 'Label is required',

    [KEYS.REMINDER_ADD_TITLE]: 'Add Reminder',
    [KEYS.REMINDER_ADD_SUBMIT]: 'Add Reminder',
    [KEYS.REMINDER_ADD_SUBMITTING]: 'Adding...',
    [KEYS.REMINDER_ADD_ERROR]: 'Failed to create reminder. Please try again.',
    [KEYS.REMINDER_EDIT_TITLE]: 'Edit Reminder',
    [KEYS.REMINDER_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.REMINDER_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.REMINDER_EDIT_ERROR]: 'Failed to update reminder. Please try again.',
    [KEYS.REMINDER_DELETE_TITLE]: 'Delete Reminder',
    [KEYS.REMINDER_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.REMINDER_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.REMINDER_DELETE_ERROR]: 'Failed to delete reminder. Please try again.',
    [KEYS.REMINDER_VIEW_SUBTITLE]: 'Reminder details',
    [KEYS.REMINDER_VIEW_ADVANCE]: 'Advance',
    [KEYS.REMINDER_VIEW_ADVANCING]: 'Advancing...',
    [KEYS.REMINDER_VIEW_ADVANCE_ERROR]: 'Failed to advance reminder. Please try again.',
    [KEYS.REMINDER_FREQ_ONCE]: 'Once',
    [KEYS.REMINDER_FREQ_DAILY]: 'Daily',
    [KEYS.REMINDER_FREQ_WEEKLY]: 'Weekly',
    [KEYS.REMINDER_FREQ_MONTHLY]: 'Monthly',
    [KEYS.REMINDER_FREQ_QUARTERLY]: 'Quarterly',
    [KEYS.REMINDER_FREQ_YEARLY]: 'Yearly',
    [KEYS.REMINDER_FIELD_TITLE_REQUIRED]: 'Title is required',
    [KEYS.REMINDER_FIELD_DATE_REQUIRED]: 'Due date is required',
    [KEYS.REMINDER_FIELD_FREQ_REQUIRED]: 'Frequency is required',
    [KEYS.REMINDER_FIELD_IS_ACTIVE]: 'Active',

    [KEYS.INVOICE_ADD_TITLE]: 'Add Invoice',
    [KEYS.INVOICE_ADD_SUBTITLE]: 'Create a new invoice',
    [KEYS.INVOICE_ADD_SUBMIT]: 'Create Invoice',
    [KEYS.INVOICE_ADD_SUBMITTING]: 'Creating...',
    [KEYS.INVOICE_ADD_ERROR]: 'Failed to create invoice. Please try again.',
    [KEYS.INVOICE_EDIT_TITLE]: 'Update Invoice',
    [KEYS.INVOICE_EDIT_SUBMIT]: 'Update Invoice',
    [KEYS.INVOICE_EDIT_SUBMITTING]: 'Updating...',
    [KEYS.INVOICE_EDIT_ERROR]: 'Failed to update invoice. Please try again.',
    [KEYS.INVOICE_DELETE_TITLE]: 'Delete Invoice',
    [KEYS.INVOICE_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.INVOICE_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.INVOICE_DELETE_ERROR]: 'Failed to delete invoice. Please try again.',
    [KEYS.INVOICE_VIEW_TITLE]: 'Invoice Details',
    [KEYS.INVOICE_FIELD_SERVICE_REQUIRED]: 'Service is required',
    [KEYS.INVOICE_FIELD_LOADING_SERVICES]: 'Loading services...',
    [KEYS.INVOICE_FIELD_SELECT_SERVICE]: 'Select a service',
    [KEYS.INVOICE_AMOUNT_ERROR]: 'Amount must be 0 or greater',
    [KEYS.INVOICE_DUE_DATE_ERROR]: 'Due date must be on or after issue date',
    [KEYS.INVOICE_PAID_DATE_ERROR]: 'Paid date must be on or after issue date',

    [KEYS.INVOICE_TEMPLATE_ADD_TITLE]: 'Add Invoice Template',
    [KEYS.INVOICE_TEMPLATE_ADD_SUBTITLE]: 'Create a reusable invoice blueprint',
    [KEYS.INVOICE_TEMPLATE_ADD_SUBMIT]: 'Add Template',
    [KEYS.INVOICE_TEMPLATE_ADD_SUBMITTING]: 'Adding...',
    [KEYS.INVOICE_TEMPLATE_ADD_ERROR]: 'Failed to create invoice template. Please try again.',
    [KEYS.INVOICE_TEMPLATE_EDIT_TITLE]: 'Edit Invoice Template',
    [KEYS.INVOICE_TEMPLATE_EDIT_SUBTITLE]: 'Update invoice template details',
    [KEYS.INVOICE_TEMPLATE_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.INVOICE_TEMPLATE_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.INVOICE_TEMPLATE_EDIT_ERROR]: 'Failed to update invoice template. Please try again.',
    [KEYS.INVOICE_TEMPLATE_DELETE_TITLE]: 'Delete Invoice Template',
    [KEYS.INVOICE_TEMPLATE_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.INVOICE_TEMPLATE_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.INVOICE_TEMPLATE_DELETE_ERROR]: 'Failed to delete invoice template. Please try again.',
    [KEYS.INVOICE_TEMPLATE_FIELD_LABEL_REQUIRED]: 'Label is required',

    [KEYS.ACTION_ADD_TITLE]: 'Add Scheduled Action',
    [KEYS.ACTION_ADD_SUBTITLE]: 'Set up automated invoice or reading creation',
    [KEYS.ACTION_ADD_SUBMIT]: 'Add Action',
    [KEYS.ACTION_ADD_SUBMITTING]: 'Adding...',
    [KEYS.ACTION_ADD_ERROR]: 'Failed to create scheduled action. Please try again.',
    [KEYS.ACTION_EDIT_TITLE]: 'Edit Scheduled Action',
    [KEYS.ACTION_EDIT_SUBTITLE]: 'Update automation settings',
    [KEYS.ACTION_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.ACTION_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.ACTION_EDIT_ERROR]: 'Failed to update scheduled action. Please try again.',
    [KEYS.ACTION_DELETE_TITLE]: 'Delete Scheduled Action',
    [KEYS.ACTION_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.ACTION_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.ACTION_DELETE_ERROR]: 'Failed to delete scheduled action. Please try again.',
    [KEYS.ACTION_RUNS_TITLE]: 'Action Runs',
    [KEYS.ACTION_RUNS_SUBTITLE]: 'History of automated executions',
    [KEYS.ACTION_FIELD_TYPE]: 'Action Type',
    [KEYS.ACTION_FIELD_TYPE_REQUIRED]: 'Action type is required',
    [KEYS.ACTION_FIELD_START_DATE]: 'Start Date',
    [KEYS.ACTION_FIELD_FREQUENCY]: 'Frequency',
    [KEYS.ACTION_FIELD_FREQUENCY_REQUIRED]: 'Frequency is required',
    [KEYS.ACTION_FIELD_NEXT_RUN_REQUIRED]: 'Next run date is required',
    [KEYS.ACTION_FIELD_INVOICE_TEMPLATE_REQUIRED]: 'Invoice template is required',
    [KEYS.ACTION_FIELD_READING_TEMPLATE_REQUIRED]: 'Reading template is required',
    [KEYS.ACTION_LOADING_TEMPLATES]: 'Loading templates...',
    [KEYS.ACTION_SELECT_TEMPLATE]: 'Select a template',
    [KEYS.ACTION_FIELD_IS_ACTIVE]: 'Active',
    [KEYS.ACTION_RUNS_RAN_AT]: 'Ran At',
    [KEYS.ACTION_RUNS_STATUS]: 'Status',
    [KEYS.ACTION_RUNS_RESULT]: 'Result',
    [KEYS.ACTION_RUNS_ERROR]: 'Error',
    [KEYS.ACTION_RUNS_SUCCESS]: 'Success',
    [KEYS.ACTION_RUNS_FAILED]: 'Failed',
    [KEYS.ACTION_RUNS_EMPTY]: 'No runs recorded yet for this action.',

    [KEYS.EDIT_PROFILE_TITLE]: 'Edit Profile',
    [KEYS.EDIT_PROFILE_SUBTITLE]: 'Update your display name',
    [KEYS.EDIT_PROFILE_SUBMIT]: 'Save',
    [KEYS.EDIT_PROFILE_SUBMITTING]: 'Saving...',
    [KEYS.EDIT_PROFILE_ERROR]: 'Failed to update profile. Please try again.',
    [KEYS.DELETE_ACCOUNT_TITLE]: 'Delete Account',
    [KEYS.DELETE_ACCOUNT_SUBTITLE]: 'This action is permanent and irreversible',
    [KEYS.DELETE_ACCOUNT_BODY]: 'All your data will be permanently deleted. Enter your password to confirm.',
    [KEYS.DELETE_ACCOUNT_PASSWORD_LABEL]: 'Your Password',
    [KEYS.DELETE_ACCOUNT_SUBMIT]: 'Confirm Delete',
    [KEYS.DELETE_ACCOUNT_SUBMITTING]: 'Deleting...',
    [KEYS.DELETE_ACCOUNT_ERROR]: 'Failed to delete account. Please try again.',
    [KEYS.EDIT_PROFILE_NAME_REQUIRED]: 'Name is required',
    [KEYS.DELETE_ACCOUNT_PASSWORD_REQUIRED]: 'Password is required to delete your account',
    [KEYS.DELETE_ACCOUNT_WARNING_TITLE]: 'Warning: Permanent Action',

    [KEYS.API_KEY_ADD_TITLE]: 'Add API Key',
    [KEYS.API_KEY_ADD_SUBTITLE]: 'Generate a new API key for external integrations',
    [KEYS.API_KEY_ADD_SUBMIT]: 'Create API Key',
    [KEYS.API_KEY_ADD_SUBMITTING]: 'Creating...',
    [KEYS.API_KEY_ADD_ERROR]: 'Failed to create API key. Please try again.',
    [KEYS.API_KEY_EDIT_TITLE]: 'Edit API Key',
    [KEYS.API_KEY_EDIT_SUBTITLE]: 'Update API key settings',
    [KEYS.API_KEY_EDIT_SUBMIT]: 'Save Changes',
    [KEYS.API_KEY_EDIT_SUBMITTING]: 'Saving...',
    [KEYS.API_KEY_EDIT_ERROR]: 'Failed to update API key. Please try again.',
    [KEYS.API_KEY_DELETE_TITLE]: 'Delete API Key',
    [KEYS.API_KEY_DELETE_SUBTITLE]: 'This will immediately revoke access',
    [KEYS.API_KEY_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.API_KEY_DELETE_ERROR]: 'Failed to delete API key. Please try again.',
    [KEYS.API_KEY_FIELD_EXPIRY]: 'Expiry Date',
    [KEYS.API_KEY_FIELD_EXPIRY_HINT]: 'Leave blank for a non-expiring key.',
    [KEYS.API_KEY_FIELD_ABILITIES]: 'Abilities',
    [KEYS.API_KEY_FULL_ACCESS_LABEL]: 'Full Access (*)',
    [KEYS.API_KEY_FULL_ACCESS_DESC]: 'Grants access to all resources and actions',
    [KEYS.API_KEY_ABILITIES_REQUIRED]: 'Select at least one ability or use full access',
    [KEYS.API_KEY_LOADING_ABILITIES]: 'Loading abilities...',
    [KEYS.API_KEY_CREATED_TITLE]: 'API Key Created!',
    [KEYS.API_KEY_CREATED_BODY]: "Copy your API key now. You won't be able to see it again.",
    [KEYS.API_KEY_CREATED_HINT]: 'Use this key in your Authorization header as a Bearer token.',
    [KEYS.API_KEY_REGEN_WARNING]: 'Regenerating this key will invalidate the existing token immediately.',
    [KEYS.API_KEY_NAME_REQUIRED]: 'Name is required',
    [KEYS.API_KEY_FIELD_EXPIRY_OPTIONAL]: '— optional',
    [KEYS.API_KEY_FIELD_EXPIRY_REMOVE_HINT]: 'Leave blank to remove the expiry date.',
    [KEYS.API_KEY_CREATED_TOKEN_LABEL]: 'Your API Token',
    [KEYS.API_KEY_DELETE_BODY]: 'Any applications using this token will immediately lose access. This cannot be reversed.',

    [KEYS.INVITE_CODE_DELETE_TITLE]: 'Delete Invite Code',
    [KEYS.INVITE_CODE_DELETE_SUBTITLE]: 'This action cannot be undone',
    [KEYS.INVITE_CODE_DELETE_BODY]: 'This invite code will be permanently deleted.',
    [KEYS.INVITE_CODE_DELETE_BODY_USED]: 'This code has already been used and will be permanently deleted.',
    [KEYS.INVITE_CODE_DELETE_SUBMITTING]: 'Deleting...',
    [KEYS.INVITE_CODE_DELETE_ERROR]: 'Failed to delete invite code. Please try again.',
    [KEYS.INVITE_CODE_CREATED_TITLE]: 'Invite Code Created!',
    [KEYS.INVITE_CODE_CREATED_BODY]: "Copy this code now. It won't be shown again.",
    [KEYS.INVITE_CODE_DELETE_BODY_UNUSED]: "This code has not been used yet. Deleting it will prevent anyone from registering with it.",
    [KEYS.INVITE_CODE_CREATED_LABEL]: 'Invite Code',


    [KEYS.LOGIN_TAGLINE]: 'Sign in to your account',
    [KEYS.LOGIN_FORGOT_PASSWORD]: 'Forgot password?',
    [KEYS.LOGIN_SUBMIT]: 'Sign in',
    [KEYS.LOGIN_SUBMITTING]: 'Signing in...',
    [KEYS.LOGIN_NO_ACCOUNT]: "Don't have an account?",
    [KEYS.LOGIN_CREATE_ONE]: 'Create one',
    [KEYS.LOGIN_RESET_SUCCESS]: 'Your password has been reset. Sign in below.',
    [KEYS.LOGIN_ERROR_GENERIC]: 'An error occurred during login',
    [KEYS.LOGIN_REMEMBER_ME]: 'Remember me',

    [KEYS.REGISTER_TAGLINE_INVITE]: 'Enter your invite code',
    [KEYS.REGISTER_TAGLINE_FORM]: 'Create your account',
    [KEYS.REGISTER_INVITE_CODE]: 'Invite Code',
    [KEYS.REGISTER_INVITE_PLACEHOLDER]: 'Paste your invite code here',
    [KEYS.REGISTER_CONTINUE]: 'Continue',
    [KEYS.REGISTER_CONTINUING]: 'Verifying...',
    [KEYS.REGISTER_CONFIRM_PASSWORD]: 'Confirm Password',
    [KEYS.REGISTER_SUBMIT]: 'Create Account',
    [KEYS.REGISTER_SUBMITTING]: 'Creating account...',
    [KEYS.REGISTER_ALREADY_ACCOUNT]: 'Already have an account?',
    [KEYS.REGISTER_SIGN_IN]: 'Sign in',
    [KEYS.REGISTER_ERROR_INVITE_REQUIRED]: 'Please enter an invite code',
    [KEYS.REGISTER_ERROR_PASSWORDS_MISMATCH]: 'Passwords do not match',
    [KEYS.REGISTER_ERROR_GENERIC]: 'An error occurred during registration',

    [KEYS.NAV_DASHBOARD]: 'Dashboard',
    [KEYS.NAV_SUPPLIERS]: 'Suppliers',
    [KEYS.NAV_SERVICES]: 'Services',
    [KEYS.NAV_INVOICES]: 'Invoices',
    [KEYS.NAV_PROFILE]: 'Profile',
    [KEYS.NAV_REMINDERS]: 'Reminders',
    [KEYS.NAV_NOTIFICATIONS]: 'Notifications',
    [KEYS.NAV_API_KEYS]: 'API Keys',
    [KEYS.NAV_SECTION_MAIN]: 'MAIN',
    [KEYS.NAV_SECTION_MANAGEMENT]: 'MANAGEMENT',
    [KEYS.NAV_LOGOUT]: 'Logout',
    [KEYS.LAYOUT_VERIFY_EMAIL]: 'Please verify your email address.',
    [KEYS.LAYOUT_VERIFY_EMAIL_SENT]: 'Verification email sent!',
    [KEYS.LAYOUT_VERIFY_EMAIL_ALREADY]: 'Your email is already verified — try refreshing.',
    [KEYS.LAYOUT_VERIFY_EMAIL_RESEND]: 'Resend email',
    [KEYS.LAYOUT_VERIFY_EMAIL_RESENDING]: 'Sending...',

    [KEYS.FORGOT_PASSWORD_TAGLINE]: 'Reset your password',
    [KEYS.FORGOT_PASSWORD_DESCRIPTION]: "Enter your email address and we'll send you a link to reset your password.",
    [KEYS.FORGOT_PASSWORD_SUBMIT]: 'Send reset link',
    [KEYS.FORGOT_PASSWORD_SUBMITTING]: 'Sending...',
    [KEYS.FORGOT_PASSWORD_SENT]: "Check your inbox — we've sent a password reset link to {email}.",
    [KEYS.FORGOT_PASSWORD_CHECK_SPAM]: "Didn't receive it? Check your spam folder or",
    [KEYS.FORGOT_PASSWORD_TRY_AGAIN]: 'try again',

    [KEYS.RESET_PASSWORD_TAGLINE]: 'Choose a new password',
    [KEYS.RESET_PASSWORD_NEW_PASSWORD]: 'New password',
    [KEYS.RESET_PASSWORD_CONFIRM_PASSWORD]: 'Confirm password',
    [KEYS.RESET_PASSWORD_SUBMIT]: 'Reset password',
    [KEYS.RESET_PASSWORD_SUBMITTING]: 'Resetting...',
    [KEYS.RESET_PASSWORD_ERROR_PASSWORDS_MISMATCH]: 'Passwords do not match.',
};

export default en;
